<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Edit Campaign</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0 mt-4">
                            <div class="row">

                                <div class="col-12">
                                    <b-form  @submit.prevent="EditCampiagnDetails">
                                      <b-form-group v-if="ProjectList.length > 0">
                                        <label>Project Name<span class="text-danger">*</span></label>
                                        <multiselect v-model="EditCampaigns.building_id" :searchable="true" placeholder="Select Project" label="text" class="form-multiselect" track-by="value" :options="ProjectList" :multiple="false" :taggable="false"></multiselect>
                                      </b-form-group>
                                      <b-form-group>
                                        <label>Start Date<span class="text-danger">*</span></label>
                                        <datetime type="date" v-model="EditCampaigns.start_date" required placeholder="Start Date">
                                        </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>End Date<span class="text-danger">*</span></label>
                                        <datetime type="date" v-model="EditCampaigns.end_date" required placeholder="End Date">
                                        </datetime>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Campaign Type<span class="text-danger">*</span></label>
                                        <b-form-select v-model="EditCampaigns.campaign_type" required :options="CampaignTypes">
                                        </b-form-select>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Title<span class="text-danger">*</span></label>
                                        <b-form-input type="text" v-model="EditCampaigns.title" required placeholder="Title"></b-form-input>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Planned Outreach<span class="text-danger">*</span></label>
                                        <b-form-input type="text" v-model="EditCampaigns.compaign_data" required placeholder="Target"></b-form-input>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Achieved<span class="text-danger">*</span></label>
                                        <b-form-input type="number" v-model="EditCampaigns.achieved" :required="EditCampaigns.executed === 'true'" placeholder="0"></b-form-input>
                                    </b-form-group>
                                    <b-form-group>
                                    <label>Enquiries / Hot<span class="text-danger">*</span></label>
                                        <b-form-input type="number" v-model="EditCampaigns.enquiries_count" :required="EditCampaigns.executed === 'true'" placeholder="0"></b-form-input>
                                    </b-form-group>
                                    <b-form-group>
                                      <label>Comment<span class="text-danger">*</span></label>
                                      <div class= "campaign-comment" v-html="EditCampaigns.comment ? EditCampaigns.comment.trim():''"></div>

                                        <b-form-textarea v-model="EditCampaigns.executive_comments" required placeholder="Description" rows="3" max-rows="6">
                                        </b-form-textarea>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-form-checkbox v-model="EditCampaigns.executed" value="true"
                                            unchecked-value="false"><span class="name mt-1">Executed</span>
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class="mt-5">
                                        <b-button type="submit" variant="primary" block>Submit</b-button>
                                    </b-form-group>
                                    </b-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { Datetime } from 'vue-datetime';
export default {
  name: 'EditCampaign',
  components: {
    Multiselect,
    datetime: Datetime
  },
  data() {
    return {
      EditCampaigns: {
        building_id: null,
        start_date: null,
        end_date: null,
        campaign_type: null,
        title: null,
        achieved: null,
        enquiries_count: null,
        buildings_broker_id: null,
        compaign_data: null,
        comment: null,
        executed: false
      },
      ProjectList: []
    }
  },
  computed: {
    CampaignTypes() {
      return this.$store.getters.CampaignTypesMaster;
    },
  },
  created() {
    this.GetCampaignOnEdit(this.$route.params.campaign_id)
  },
  methods: {
    GetCampaignOnEdit(campaign_id) {
      let queryP = {}
      queryP['edit'] = true
      queryP['campaign_id'] = campaign_id
      this.$axios.get(`buildings/broker_campaign_details`, { params: queryP }).then((res) => {
        this.EditCampaigns = JSON.parse(JSON.stringify(res.data).substring(1, JSON.stringify(res.data).length-1));
        this.EditCampaigns['bb_broker_id'] = this.EditCampaigns.broker_id
        delete this.EditCampaigns.broker_id
        delete this.EditCampaigns.broker_name
        delete this.EditCampaigns.project_name
        delete this.EditCampaigns.firm_name
        this.getprojects()
      });
    },
    getprojects() {
      this.ProjectList = []
      let queryP = {}
      queryP['building_id'] = this.EditCampaigns.building_id.value;
      queryP['broker_id'] = this.EditCampaigns.bb_broker_id;
      queryP['id'] = this.EditCampaigns.buildings_broker_id;
      this.$axios.get(`buildings/projects`, { params: queryP }).then((res) => {
        res.data.projects.forEach((item,index) => {
          this.ProjectList.push({value: item.id, text: item.name})
        });
        this.ProjectList.unshift({value: null, text: 'Select Project'})
      });
    },
    EditCampiagnDetails() {
      let queryP = {}
      queryP['campaign_id'] = this.$route.params.campaign_id
      if (this.EditCampaigns.building_id) {
        this.EditCampaigns.building_id = this.EditCampaigns.building_id.value
      }
      this.$axios
        .put(`buildings/brokers/campaigns`, { buildings_brokers_campaign  : this.EditCampaigns }, {params: queryP})
        .then((res) => {
          swal({
            title: "Campaign Updated!",
            icon: "success",
          }).then(this.$router.replace({ name: "CampaignDetails", params: { id: this.$route.params.campaign_id } }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    }
  }
}
</script>
<style scoped>
  .campaign-comment{
    white-space: pre-line;
  }
</style>